export default __webpack_public_path__ + "static/media/aasaan-text.381c8f0b.png";